export default {"src":"/_next/static/media/pharmacy-patient-info.28a95d02.svg","height":581,"width":624,"blurWidth":0,"blurHeight":0};